export default __webpack_public_path__ + "static/media/Thought Gear Indoctrinate.8d649e0a.png";